import { Tooltip as ReactTooltip } from 'react-tooltip';

const tooltipStyles = {
  zIndex: 1000,
  textAlign: 'center',
  borderRadius: '6px',
  whiteSpace: 'pre-line',
  maxWidth: '350px',
};

const TOOLTIP_IDS = [
  'message-content-type',
  'message-publication-date',
  'message-platform',
  'message-followers',
  'source-info',
  'parent-source-info',
  'actor-info',
  'publication-link',
  'message-views',
  'message-comments',
  'message-reposts',
  'message-reactions',
  'message-engagement',
  'message-similarity',
];

export function MessageTooltips({ scope, style }) {
  const mergedStyle = style ? { ...tooltipStyles, ...style } : tooltipStyles;
  // When scope is provided, derive a unique id prefix so that multiple scoped
  // instances (e.g. a page list + an open modal) don't share the same tooltip
  // id and cross-fire via react-tooltip's global event bus.
  // anchorSelect still uses the original data-tooltip-id values as CSS attribute
  // selectors, so nothing in the anchor components needs to change.
  const scopePrefix = scope
    ? scope.replace(/^[^a-zA-Z0-9]+/, '').replace(/[^a-zA-Z0-9]/g, '-') + '-'
    : '';
  return (
    <>
      {TOOLTIP_IDS.map((id) => (
        <ReactTooltip
          key={id}
          id={`${scopePrefix}${id}`}
          anchorSelect={scope ? `${scope} [data-tooltip-id="${id}"]` : undefined}
          place="bottom"
          style={mergedStyle}
        />
      ))}
    </>
  );
}
